import React from 'react';

const PageWrapper = ({ children, className = "" }) => {
  return (
    <div className="min-h-screen bg-gray-50">
      <div className={`max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6 ${className}`}>
        {children}
      </div>
    </div>
  );
};

export default PageWrapper;
